import axiosClient from "utils/api/axios-client";

const restaurantContractApi = {
  getAll: (params) => {
    const url = "/api/v1/restaurant-contracts";
    return axiosClient.get(url, { params });
  },
  getById: (id) => {
    const url = `/api/v1/restaurant-contracts/${id}`;
    return axiosClient.get(url);
  },
  verify: (id) => {
    const url = `/api/v1/restaurant-contracts/${id}/verify`;
    return axiosClient.put(url);
  },
  reject: (id, reason) => {
    const url = `/api/v1/restaurant-contracts/${id}/reject`;
    return axiosClient.put(url, { reason });
  },
  delete: (id) => {
    const url = `/api/v1/restaurant-contracts/${id}`;
    return axiosClient.delete(url);
  },
};

export default restaurantContractApi;
